(() => {
  const MOMENT_PATH = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/moments\/([^/?#]+)/;
  const COOKIE = 'k_clk';
  const MAX_AGE_SECONDS = 60 * 60 * 24 * 90;
  const TRACKER_URL = 'https://ct.kurlective.com/r/';
  const CLICK_ID_CHANNELS = { gclid: 'google', gbraid: 'google', wbraid: 'google', msclkid: 'bing' };
  const CLICK_ID_VALUE = /^[\w.-]{1,512}$/;
  const MAX_TRACKED_URL_LENGTH = 2048;

  const privacy = () => window.Shopify?.customerPrivacy;
  const marketingAllowed = () => Boolean(privacy()?.marketingAllowed?.());

  const withPrivacy = (callback) => {
    if (privacy()) return callback();
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) callback();
    });
  };

  const readClick = () => {
    const raw = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${COOKIE}=`));
    if (!raw) return null;
    try {
      return JSON.parse(decodeURIComponent(raw.slice(COOKIE.length + 1)));
    } catch {
      return null;
    }
  };

  const landingClick = () => {
    const params = new URLSearchParams(window.location.search);
    const key = Object.keys(CLICK_ID_CHANNELS).find((name) => CLICK_ID_VALUE.test(params.get(name) || ''));
    return key ? { k: key, v: params.get(key) } : null;
  };

  const captureClick = () => {
    const click = landingClick();
    if (!click) return;
    withPrivacy(() => {
      if (!marketingAllowed()) return;
      const value = JSON.stringify({ ...click, t: Date.now() });
      document.cookie = `${COOKIE}=${encodeURIComponent(value)}; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax; Secure`;
    });
  };

  const isAwin = (url) => /(^|\.)awin1\.com$/i.test(url.hostname);
  const isAmazon = (url) => /(^|\.)amazon\.co\.uk$/i.test(url.hostname);

  const trackedHref = (url) => {
    const click = marketingAllowed() ? landingClick() || readClick() : null;
    if (!click || !isAwin(url) || url.href.length > MAX_TRACKED_URL_LENGTH || !CLICK_ID_CHANNELS[click.k] || !CLICK_ID_VALUE.test(click.v)) return null;
    const tracked = new URL(TRACKER_URL);
    tracked.searchParams.set('n', 'awin');
    tracked.searchParams.set('channel', CLICK_ID_CHANNELS[click.k]);
    tracked.searchParams.set(click.k, click.v);
    tracked.searchParams.set('url', url.href);
    return tracked.href;
  };

  const sourceMoment = () => {
    try {
      const referrer = new URL(document.referrer);
      if (referrer.origin !== window.location.origin) return undefined;
      return referrer.pathname.match(MOMENT_PATH)?.[1];
    } catch {
      return undefined;
    }
  };

  const onOutboundClick = (event) => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest?.('a[data-k-outbound]');
    if (!link) return;
    const d = link.dataset;
    d.kOutboundHref ||= link.href;
    const url = new URL(d.kOutboundHref, window.location.href);
    const routed = trackedHref(url);
    if (routed) {
      link.href = routed;
      setTimeout(() => (link.href = url.href));
    }
    window.Shopify?.analytics?.publish?.('kurlective_outbound_click', {
      url: url.href,
      link_domain: url.hostname,
      link_type: isAwin(url) ? 'awin' : isAmazon(url) ? 'amazon' : 'direct',
      routed_via_tracker: routed ? 'yes' : 'no',
      product_id: d.productId,
      product_name: d.productName,
      retailer: d.retailer,
      brand: d.brand || undefined,
      category: d.category || undefined,
      product_type: d.productType || undefined,
      gender: d.gender || undefined,
      on_sale: d.onSale,
      monetised: d.monetised || undefined,
      source_moment: sourceMoment(),
      price: d.price ? Number(d.price) : undefined,
      currency: d.currency,
      market: d.market,
      availability: d.availability,
      cta: d.cta,
    });
  };

  withPrivacy(() => {});
  captureClick();
  document.addEventListener('visitorConsentCollected', () => {
    if (!marketingAllowed()) document.cookie = `${COOKIE}=; Max-Age=0; Path=/; SameSite=Lax; Secure`;
    captureClick();
  });
  document.addEventListener('click', onOutboundClick, true);
  document.addEventListener('auxclick', onOutboundClick, true);
})();
